// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"550":"5ff84373","787":"349b0e60"}[chunkId] + ".chunk.js";
};